const { io } = require("socket.io-client");

let ami = { 'on': function () { }, 'emit': function () { } };
try {
	ami = io(`${location.protocol}//${location.hostname}:3020/`);
} catch (error) {
	console.error(error);
}

module.exports = {
	ami
}
